import { PublicClientApplication } from '@azure/msal-browser';

const login = {
	postLoginRedirectStorageKey: 'postLoginRedirectUrl',
	urlAuthInitiate: `${import.meta.env.VITE_SKOPEI_OIDC_AUTHORITY_URL_V2}/oauth2/v2.0/initiate`,
	urlAuthChallenge: `${import.meta.env.VITE_SKOPEI_OIDC_AUTHORITY_URL_V2}/oauth2/v2.0/challenge`,
	urlAuthToken: `${import.meta.env.VITE_SKOPEI_OIDC_AUTHORITY_URL_V2}/oauth2/v2.0/token`,
	signInScopes:
		'openid email offline_access ' + import.meta.env.VITE_SKOPEI_AUTH_SCOPE + '/managementApi',
	signInScopesArray: [
		'openid',
		'profile',
		'email',
		'offline_access',
		import.meta.env.VITE_SKOPEI_AUTH_SCOPE + '/managementApi',
	],
	msalInstance: new PublicClientApplication({
		auth: {
			clientId: import.meta.env.VITE_SKOPEI_OIDC_CLIENT_ID,
			authority: import.meta.env.VITE_SKOPEI_OIDC_AUTHORITY_URL,
			redirectUri: window.location.origin + '/auth/signin-callback-oidc',
			knownAuthorities: ['skopeiIdentity.ciamlogin.com'],
		},
		cache: {
			cacheLocation: 'localStorage',
		},
	}),
} as const;

export default login;
